/**
 * Timezone-related constants
 */

/**
 * Texas timezone identifier
 * Used for specific timezone conversions
 */
export const TEXAS_TIMEZONE = 'America/Chicago';

/**
 * Default timezone for the application
 * (Currently set to Texas timezone)
 */
export const DEFAULT_TIMEZONE = TEXAS_TIMEZONE;
